import React from "react";

const PointerToolIcon = () => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 403 484"
    width="403"
    height="484"
  >
    <path d="m336 485h-192c-9.6 0-16-6.4-16-16 0-24-11.2-38.4-28.8-60.8-9.6-11.2-20.8-25.6-32-43.2-30.4-48-57.6-105.6-64-126.4-6.4-20.8-1.6-35.2 4.8-43.2 6.4-9.6 19.2-14.4 33.6-14.4 19.2 0 38.4 16 56 36.8v-164.8c0-27.2 20.8-48 48-48 27.2 0 48 20.8 48 48v67.2c4.8-1.6 9.6-3.2 16-3.2 17.6 0 32 9.6 40 22.4 6.4-4.8 14.4-6.4 22.4-6.4 22.4 0 40 14.4 46.4 35.2 4.8-1.6 11.2-3.2 17.6-3.2 27.2 0 48 20.8 48 48v48c0 41.6-8 75.2-16 107.2-8 32-16 62.4-16 100.8 0 9.6-6.4 16-16 16zm-177.6-32h161.6c1.6-35.2 9.6-64 16-92.8 8-32 16-62.4 16-99.2v-48c0-9.6-6.4-16-16-16-9.6 0-16 6.4-16 16v16c0 9.6-6.4 16-16 16-9.6 0-16-6.4-16-16v-48c0-9.6-6.4-16-16-16-9.6 0-16 6.4-16 16v32c0 9.6-6.4 16-16 16-9.6 0-16-6.4-16-16v-48c0-9.6-6.4-16-16-16-9.6 0-16 6.4-16 16v32c0 9.6-6.4 16-16 16-9.6 0-16-6.4-16-16v-144c0-9.6-6.4-16-16-16-9.6 0-16 6.4-16 16v240c0 9.6-6.4 16-16 16-9.6 0-16-6.4-16-16v-12.8c-14.4-36.8-44.8-67.2-56-67.2-3.2 0-6.4 0-8 1.6q-2.4 2.4 0 14.4c4.8 17.6 28.8 68.8 60.8 120 9.6 16 19.2 27.2 28.8 40 17.6 19.2 33.6 36.8 36.8 64z" />
  </svg>
);

export default PointerToolIcon;
